import welcomeVideoPanel from './welcomeVideoPanel';
import exampleFocusPanel from './exampleFocusPanel';
import blogManagerPanel from './blogManagerPanel';
import shoutOutTemplatesPanel from './shoutOutTemplatesPanel';
import aviaryPanel from './aviaryPanel';
import organizeImagesPanel from './organizeImagesPanel';
import outOfGridMobilePanel from './outOfGridMobilePanel/outOfGridMobilePanel';
import outOfGridDesktopPanel from './outOfGridDesktopPanel';
import outOfContainerGridPanel from './outOfContainerGridPanel';
import dragToHeaderPanel from './dragToHeaderPanel';
import attachToSOSPPanel from './attachToSOSPPanel';
import detachedFromSOSPPanel from './detachedFromSOSPPanel';
import spotifySearchFocusPanel from './spotifySearchFocusPanel';
import iTunsLinkMaker from './iTunsLinkMaker';
import corvidDevModePanel from './corvidDevModePanel/corvidDevModePanel';
import confirmPublishPanel from './confirmPublishPanel/confirmPublishPanel';
import howToVideoGalleryPanel from './howToVideoGalleryPanel';
import { FeedbackPanel as feedbackPanel } from './feedbackPanel';
import getTrafficPanel from './getTrafficPanel';
import promotionModalPanel from './promotionModalPanel';
import sizeRestrictionPanel from './sizeRestrictionPanel';
import cameFromADIVideoPanel from './cameFromADIVideoPanel';
import howToVideoPlayer from './howToVideoPlayer';
import failPanel from './failPanel';
import createNewTextBoxPanel from './createNewTextBoxPanel';
import popupTemplate from './popupTemplate';
import siteImageOptimizationPanel from './siteImageOptimizationPanel';
import siteMembersSettingsPanel from './siteMembersSettingsPanel';
import newFeaturesVideoPanel from './newFeaturesVideoPanel';
import mobileFriendlyPanel from './mobileFriendlyPanel/mobileFriendlyPanel';
import mobileEditorFirstTimeVideoPanel from './mobileEditorFirstTimeVideoPanel';
import mobileEditorFirstTimePanel from './mobileEditorFirstTimePanel';
import backToADIPanel from './backToADIPanel';
import packageAndUpdatePanel from './packageAndUpdatePanel/packageAndUpdatePanel';
import menuContainerUpgradePanel from './menuContainerUpgradePanel';
import customTypeValueEditPanel from './customTypeValueEditPanel/customTypeValueEditPanel';
import browserThemeColorPanel from './browserThemeColorPanel';
import languagePublishSuccessPanel from './languagePublishSuccessPanel';
import languageUnpublishPanel from './languageUnpublishPanel';
import languagePickerDeletePanel from './languagePickerDeletePanel';
import multilingualComponentChangedPanel from './multilingualComponentChangedPanel/multilingualComponentChangedPanel';
import googleTranslateWarningPanel from './multilingualGoogleTranslateWarningPanel/multilingualGoogleTranslateWarningPanel';
import googleTranslateFailed from './googleTranslateFailed';
import confirmResetAndClose from './confirmResetAndClose';
import confirmOpenWidget from './confirmOpenWidget';
import customErrorPagePanel from './customErrorPagePanel/customErrorPagePanel';
import progressBarPanel from './progressBarPanel/progressBarPanel';
import fakeProgressBarPanel from './progressBarPanel/fakeProgressBarPanel';
import renameSavedComponentsPanel from './renameSavedComponentsPanel/renameSavedComponentsPanel';
import deleteSavedComponentsPanel from './deleteSavedComponentsPanel/deleteSavedComponentsPanel';
import saveToMyElementsPanel from './saveToMyElementsPanel/saveToMyElementsPanel';
import welcomeTourPanel from './welcomeTourPanel/welcomeTourPanel';
import notEnoughWordsToGoogleTranslate from './notEnoughWordsToGoogleTranslate';
import changeBusinessTypePanel from './changeBusinessTypePanel/changeBusinessTypePanel';
import aiSectionCreatorErrorPanel from './aiSectionCreatorErrorPanel';
import aiWriterErrorPanel from './aiWriterErrorPanel';
import siteAccessPanel from './siteAccessPanel/siteAccessPanel';
import mediaImageBooster from './mediaImageBoosterPanel/mediaImageBoosterPanel';

export {
  corvidDevModePanel,
  confirmPublishPanel,
  welcomeVideoPanel,
  exampleFocusPanel,
  blogManagerPanel,
  shoutOutTemplatesPanel,
  aviaryPanel,
  organizeImagesPanel,
  outOfGridMobilePanel,
  outOfGridDesktopPanel,
  outOfContainerGridPanel,
  dragToHeaderPanel,
  attachToSOSPPanel,
  detachedFromSOSPPanel,
  spotifySearchFocusPanel,
  iTunsLinkMaker,
  howToVideoGalleryPanel,
  feedbackPanel,
  getTrafficPanel,
  promotionModalPanel,
  sizeRestrictionPanel,
  cameFromADIVideoPanel,
  howToVideoPlayer,
  failPanel,
  createNewTextBoxPanel,
  popupTemplate,
  siteImageOptimizationPanel,
  siteMembersSettingsPanel,
  newFeaturesVideoPanel,
  mobileFriendlyPanel,
  mobileEditorFirstTimeVideoPanel,
  mobileEditorFirstTimePanel,
  backToADIPanel,
  packageAndUpdatePanel,
  menuContainerUpgradePanel,
  customTypeValueEditPanel,
  browserThemeColorPanel,
  languagePublishSuccessPanel,
  languageUnpublishPanel,
  languagePickerDeletePanel,
  multilingualComponentChangedPanel,
  googleTranslateFailed,
  confirmResetAndClose,
  confirmOpenWidget,
  customErrorPagePanel,
  progressBarPanel,
  fakeProgressBarPanel,
  renameSavedComponentsPanel,
  deleteSavedComponentsPanel,
  saveToMyElementsPanel,
  welcomeTourPanel,
  notEnoughWordsToGoogleTranslate,
  googleTranslateWarningPanel,
  changeBusinessTypePanel,
  aiSectionCreatorErrorPanel,
  aiWriterErrorPanel,
  siteAccessPanel,
  mediaImageBooster,
};
